module.exports = __webpack_public_path__ + "img/date.43ab8c85.svg";